import PageContent from './components/PageContent'

const Overview = () => (
  <PageContent />
)

export default Overview
